import { disconnect, removeCredentials } from '@/services/AuthorizationService';
import { Brand } from '@/types/Brand';
import getEnv from '@/utils/env';

export const globalLogout = ({
  brand = Brand.CETELEM,
  dispatch,
  navigate = () => {},
}: {
  brand: Brand;
  dispatch: Function;
  navigate?: any;
}) => {
  disconnect()
    .then(() => {
      sessionStorage.removeItem('lastURL');
      removeCredentials(dispatch);
    })
    .catch((err) => console.error('err', err))
    .finally(() => {
      if (getEnv().PROFIL === 'PARTENAIRE') {
        const redirectUri = window.origin + '/#/' + brand + '/logout/';
        window.location.replace(
          `${
            getEnv().openIdConnectUrl
          }/idp/startSLO.ping?TargetResource=${redirectUri}`
        );
      } else {
        navigate('logout');
      }
    });
};
